import * as React from 'react';
import { Link } from 'react-router-dom';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { HelpEmailLink, HelpPhoneLink } from '../../../common/HelpLinks';
import { prospectPages, prospectPath } from '../ProspectRouter';

const HelpPage = () => (
    <Row>
        <Col className="help-or-about-us-page">
            <section className="title">HELP</section>
            <section>The Tour24 team is available to help.</section>
            <section>
                <div>
                    <span>
                        Please check out our{' '}
                        <Link to={prospectPath(prospectPages.tour24Faq)}>
                            <b>FAQs</b>.
                        </Link>
                        <br />
                        OR please contact us at:
                    </span>
                </div>
                <div>
                    Phone: <HelpPhoneLink />
                </div>
                <div>
                    <span>
                        Email: <HelpEmailLink />
                    </span>
                </div>
            </section>
        </Col>
    </Row>
);

export default HelpPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/HelpPage.tsx